
import { memo } from 'react';
import { Button } from '@/components/ui/button';
import { Shield } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useAdmin } from '@/hooks/useAdmin';

const AdminAccessButton = memo(() => {
  const { isAdmin, isLoading } = useAdmin();
  const navigate = useNavigate();

  // 只在開發環境且有問題時才輸出日誌
  if (process.env.NODE_ENV === 'development' && isLoading) {
    console.log('AdminAccessButton: Still loading admin status');
  }

  if (isLoading) {
    return (
      <div className="w-8 h-8 bg-gray-200 animate-pulse rounded"></div>
    );
  }

  if (!isAdmin) {
    // 不再輸出 "User is not admin" 避免混淆
    return null;
  }

  const handleAdminAccess = () => {
    console.log('AdminAccessButton: Navigating to admin panel');
    navigate('/jay');
  };

  return (
    <Button 
      variant="outline" 
      size="sm"
      onClick={handleAdminAccess}
      className="bg-red-50 border-red-200 text-red-700 hover:bg-red-100 font-medium"
    >
      <Shield className="w-4 h-4 mr-2" />
      進入後台管理
    </Button>
  );
});

AdminAccessButton.displayName = 'AdminAccessButton';

export default AdminAccessButton;
